// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3DSkO","title":"ClientReferral_title__3oiYB","itemText":"ClientReferral_itemText__3Y2an"};